import React from "react";

const TermsAndConditions = () => {
  return (
    <div>
      <p class="mb-2">
        The company, <strong>BGS URBAN NIDHI LIMITED</strong> incorporated on 02
        November 2020 under Companies Act, 2013. Nidhi Company carries on the
        business of taking deposits and lending money among its members. Nidhi
        Company carries no business other than defined in the Memorandum of
        Association of the Company.
      </p>
      <p class="mb-2">
        2) Mode of repayment of deposit shall be through cash or cheque as per
        the request of depositee. Any payment of Rs. 20,000 and above shall be
        made through cheque only.
      </p>
      <p class="mb-2">
        3) The maturity period of deposit may vary from 12 months to 60 months
        as per the choice of the depositor and schemes framed by the company
        from time to time:
      </p>
      <p class="mb-2">
        The maximum rate of interest on the deposits shall be as follows:
      </p>
      <table class="w-full mb-4 border-collapse border border-zinc-400 dark:border-zinc-600">
        <thead>
          <tr>
            <th class="border border-zinc-400 dark:border-zinc-600 p-2 font-semibold">
              S. No.
            </th>
            <th class="border border-zinc-400 dark:border-zinc-600 p-2 font-semibold">
              Deposit Type
            </th>
            <th class="border border-zinc-400 dark:border-zinc-600 p-2 font-semibold">
              Rate of Interest
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="border border-zinc-400 dark:border-zinc-600 p-2 text-center">
              1
            </td>
            <td class="border border-zinc-400 dark:border-zinc-600 p-2">
              Savings Account
            </td>
            <td class="border border-zinc-400 dark:border-zinc-600 p-2 text-center">
              3%
            </td>
          </tr>
          <tr>
            <td class="border border-zinc-400 dark:border-zinc-600 p-2 text-center">
              2
            </td>
            <td class="border border-zinc-400 dark:border-zinc-600 p-2">
              Daily Pigmy
            </td>
            <td class="border border-zinc-400 dark:border-zinc-600 p-2 text-center">
              6 to 8.2%
            </td>
          </tr>
          <tr>
            <td class="border border-zinc-400 dark:border-zinc-600 p-2 text-center">
              3
            </td>
            <td class="border border-zinc-400 dark:border-zinc-600 p-2">
              Recurring Deposit
            </td>
            <td class="border border-zinc-400 dark:border-zinc-600 p-2 text-center">
              7.5 to 12.5%
            </td>
          </tr>
          <tr>
            <td class="border border-zinc-400 dark:border-zinc-600 p-2 text-center">
              4
            </td>
            <td class="border border-zinc-400 dark:border-zinc-600 p-2">
              Fixed Deposit
            </td>
            <td class="border border-zinc-400 dark:border-zinc-600 p-2 text-center">
              6 to 11.5%
            </td>
          </tr>
        </tbody>
      </table>
      <p class="mb-2">
        However, the above interest is subject to the following conditions:
      </p>
      <ul class="list-disc list-inside mb-4">
        <li>
          No deposit shall be repaid within a period of three months from the
          date of acceptance.
        </li>
        <li>
          If deposit is withdrawn at the request of the depositor after three
          months, the depositor shall not be entitled to any interest up to six
          months from the date of deposits.
        </li>
        <li>
          Where at the request of the depositor, a Nidhi makes repayment of a
          deposit before the expiry of the period for which such deposit was
          accepted by Nidhi, the rate of interest payable by Nidhi on such
          deposit shall be reduced by two percent from the rate which Nidhi
          would have ordinarily paid, had the deposit been accepted for the
          period for which such deposit had run.
        </li>
        <li>
          However, in the event of death of a depositor, the deposit may be
          repaid prematurely to the surviving depositor or depositors in the
          case of joint holding with survivor clause, or to the nominee or to
          legal heir with interest up to the date of repayment at the rate which
          the company would have ordinarily paid, had such deposit been accepted
          for the period for which such deposit had run.
        </li>
      </ul>
      <p class="mb-2">
        4) As the company incorporated in current fiscal year hence the
        financial summary of company is not available.
      </p>
      <p class="mb-2">
        5) The depositor may be paid either monthly, quarterly, half yearly, or
        yearly as agreed between the depositor and the company or as per the
        scheme framed by the company.
      </p>
      <p class="mb-2">
        6) The Nidhi Company shall also have the right to repay the deposits
        prematurely and can make any adhoc payment to the depositor as per the
        policy.
      </p>
      <p class="mb-2">
        7) The Nidhi Company carries a right to reserve; it may deny keeping the
        deposit or lending to any person or a group without stating any reason
        for it.
      </p>
      <p class="mb-2">
        8) The fixed deposit may be renewed at the request of the depositor.
      </p>
      <p class="mb-2">
        9) In case of non-payment of the deposit or part thereof as per the
        terms and conditions of such deposit, the depositor may approach the
        Registrar of Companies having jurisdiction over Nidhi.
      </p>
      <p class="mb-2">
        10) In case of any deficiency of Nidhi in servicing its depositors, the
        depositor may approach the National Consumers Disputes Redressal Forum,
        the State Consumers Disputes Redressal Forum or District Consumers
        Disputes Redressal Forum, as the case may be, for redressal of his
        relief.
      </p>
      <p class="mb-2">
        11) Declaration by Board of Directors: Board of Directors of the Company
        hereby declare that all the requirements of Companies Act, 2013 (18 of
        2013) and the rules including the Nidhi rules, 2014 made there under in
        respect of the subject matter of this form and matters incidental
        thereto have been complied with. We also declare that all the
        information given herein above is true, correct and complete including
        the attachments to this form and nothing material has been suppressed.
        We also declare that it is our first financial year so we don't have
        financial summary, however, the company has INR 10 Lacs as its Paid-up
        capital and also complying with Nidhi rules to run a true and fair
        business.
      </p>
      <p class="mb-4">
        <strong>12)</strong> Important Note: Neither Reserve Bank of India (RBI)
        nor Central Government does undertake any responsibility for the
        financial soundness of Nidhi or for the correctness of any of the
        statement or the representations made or opinions expressed by Nidhi and
        the deposits accepted by Nidhi are not insured and the repayment of
        deposits is not guaranteed by either the Central Government or the
        Reserve Bank of India.
      </p>
      <p class="mb-4">
        <strong>13)</strong> Nidhi shall obtain documentary evidence of the
        depositor in the form of proof of identity and address as under:
      </p>
      <div class="overflow-x-auto mb-4">
        <table class="min-w-full border border-zinc-300 dark:border-zinc-700">
          <thead>
            <tr class="bg-zinc-100">
              <th class="border border-zinc-300 dark:border-zinc-700 p-2 font-semibold">
                A) Proof of Identity (any one of the following)
              </th>
              <th class="border border-zinc-300 dark:border-zinc-700 p-2 font-semibold">
                B) Proof of Address (any one of the following)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="border border-zinc-300 dark:border-zinc-700 p-2">
                - Passport
              </td>
              <td class="border border-zinc-300 dark:border-zinc-700 p-2">
                - Passport
              </td>
            </tr>
            <tr>
              <td class="border border-zinc-300 dark:border-zinc-700 p-2">
                - Unique Identification Number
              </td>
              <td class="border border-zinc-300 dark:border-zinc-700 p-2">
                - Unique Identification Number
              </td>
            </tr>
            <tr>
              <td class="border border-zinc-300 dark:border-zinc-700 p-2">
                - Income Tax PAN Card
              </td>
              <td class="border border-zinc-300 dark:border-zinc-700 p-2">
                - Driving License
              </td>
            </tr>
            <tr>
              <td class="border border-zinc-300 dark:border-zinc-700 p-2">
                - Elector’s Photo Identity Card
              </td>
              <td class="border border-zinc-300 dark:border-zinc-700 p-2">
                - Telephone Bill (Shouldn’t be more than two months old)
              </td>
            </tr>
            <tr>
              <td class="border border-zinc-300 dark:border-zinc-700 p-2">
                - Driving License
              </td>
              <td class="border border-zinc-300 dark:border-zinc-700 p-2">
                - Bank Account Statement (Shouldn’t be more than 2 months old)
              </td>
            </tr>
            <tr>
              <td class="border border-zinc-300 dark:border-zinc-700 p-2">
                - Defence ID
              </td>
              <td class="border border-zinc-300 dark:border-zinc-700 p-2">
                - Electricity Bill (Shouldn’t be more than 2 months old)
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mb-4">
        <h2 class="font-bold">
          Exhibit 1: Terms and Conditions for Accepting Deposits
        </h2>
        <ol class="list-decimal list-inside">
          <li>Deposit will be accepted from Members Only.</li>
          <li>
            Deposit can be accepted in cash or through cheque subject to
            verification.
          </li>
          <li>
            Recurring deposits shall be accepted for a minimum period of twelve
            months and a maximum period of sixty months.
          </li>
          <li>
            In case of recurring deposits relating to mortgage loans, the
            maximum period of recurring deposits shall correspond to the
            repayment period of such loans granted by Nidhi.
          </li>
          <li>
            The maximum balance in a savings deposit account at any given time
            qualifying for interest shall not exceed one lakh rupees at any
            point of time and the rate of interest shall not exceed two percent
            above the rate of interest payable on savings bank account by
            nationalized banks.
          </li>
          <li>
            The maximum rate of interest offered on savings account will be 3%.
          </li>
          <li>
            The maximum rate on Daily (Pigmy) 6% subject to some conditions.
          </li>
          <li>
            The maximum rate on Fixed deposit is 12.50% subject to some
            conditions.
          </li>
          <li>
            The maximum rate on Recurring deposit is 11.50% subject to some
            conditions.
          </li>
        </ol>
      </div>
      <div>
        <h2 class="font-bold">Exhibit 2: Terms and Conditions for Lending</h2>
        <ol class="list-decimal list-inside">
          <li>Any Individual loan shall not exceed INR 2.0 Lacs.</li>
          <li>
            Nidhi shall provide loan only against gold, immovable Property and
            Deposits.
          </li>
          <li>
            The value of Gold loan shall not exceed 80% of the fine gold
            secured.
          </li>
          <li>
            The value of loan against immovable property shall not exceed 50% of
            the property secured.
          </li>
          <li>The repayment of gold loan shall not exceed one year.</li>
          <li>
            The repayment of loan against immovable property shall not exceed 7
            years.
          </li>
          <li>
            The repayment of loan against FDR shall not exceed the maturity
            period of Deposits.
          </li>
          <li>
            The maximum interest rate charged on loan shall not exceed 20.00%.
          </li>
          <li>
            Any interest due or loan due shall be subject to prudential norms.
          </li>
        </ol>
      </div>
    </div>
  );
};

export default TermsAndConditions;
